module.exports = __webpack_public_path__ + "static/media/aboutimg.9af75fed.jpg";